import { Message } from 'element-ui';
import { noticePage } from '@/service';
/**
 * state(类似存储全局变量的数据)
 * getters(提供用来获取state数据的方法)
 * actions(提供跟后台接口打交道的方法， 并调用mutations提供的方法)
 * mutations(提供存储设置state数据的方法)
 */
let state = {
    noticePage: [],
}
let getters = {
    noticePageList: state => state.noticePage.filter(item => !item.status),
}
let mutations = {
    setnoticePage(state, val) {
        state.noticePage = val;
        sessionStorage.setItem('$noticePage', JSON.stringify(val));
    },
}
let actions = {
    setnoticePageAsync(context) {
        const params = {
            limit: 3,
            offset: 1,
            status: 0,  //status 0 未读 1已读 不传为全部
        };
        noticePage(params).then((res) => {
            if (res.code != 200) {
                Message({
                    showClose: true,
                    message: res.message,
                    type: 'error',
                    duration: 2 * 1000
                })
                return;
            }
            context.commit('setnoticePage', res.data.records);
        });
    },
}
export default {
    namespaced: true, // namespaced 属性，限定命名空间
    state,
    getters,
    mutations,
    actions
}